import React, {Component, useEffect, useState} from 'react';

import ChildProgressReviewHeaderForm from "./ChildProgressReviewHeaderForm";
import ChildProgressReviewTabbedForm from "./ReactChildProgressReviewTabbedForm";
import SpinnerDiv from "ui/SpinnerDiv";
import {getChildDetailsWithPromise} from "root/DataFunctions/ChildDataFns";
import {getDataFromResponse, handleAjaxError} from "root/DataFunctions/BaseDataFns";
import {getWorkItemWithPromise} from "root/DataFunctions/WorkItemFns";
import ChildProgressReviewTabbedForm2 from "root/ProgressReviewPost16/ChildProgressReviewTabbedForm2";
import TabProvider from "root/ProgressReviewPost16/TabProvider";

const UpdateProgressReviewPage = ({workitem_id, child_id, review_id, return_url, user_type}) =>
{
    const [childId, setChildId] = useState(child_id);
    const [reviewId, setReviewId] = useState(review_id);
    const [isLoading, setIsLoading] = useState(true);

    const [childIsLoading, setChildIsLoading] = useState(true);
    const [isPPP, setIsPPP] = useState(false);

    useEffect(() =>
    {
        if (workitem_id !== null && workitem_id !== undefined && +workitem_id !== 0)
        {
            getDataUsingWorkitem(workitem_id);
        }
        else
        {
            setIsLoading(false);
            setReviewId(review_id);
        }
    }, []);

    useEffect(() => {
        if (child_id !== null && child_id !== undefined && +child_id !== 0)
        {
            getChild(child_id);
        }

    }, []);

    const getChild = (actual_child_id) =>
    {
        getChildDetailsWithPromise(actual_child_id, []).then((response) =>
        {
            console.log(response);

            const rec = getDataFromResponse(response)[0];

            const ppp = +rec.ppplus_flag === 1;

            setIsPPP(ppp);
            setChildIsLoading(false);
        })
    }


    const getDataUsingWorkitem = (workitemid) =>
    {
        getWorkItemWithPromise(workitemid).then(response =>
        {
            const rec = getDataFromResponse(response)[0];

            const metadata = rec.metadata;

            const reviewid = metadata.progress_review_id;
            const childid = metadata.child_id;

            getChild(childid);

            getDataUsingProgressReview(reviewid, childid);
        })
            .catch((jqXHR, textStatus, error) =>
            {
                handleAjaxError(jqXHR, textStatus, error);
            });
    }

    const getDataUsingProgressReview = (reviewid, childid) =>
    {
        const returnUrl = atob(return_url);

        $.ajax({
            type: 'GET',
            url: Globals.APIFolder + '/reviews/' + reviewid,
            success: (data) => {

                if (checkError(data))
                {
                    let d = data.data;

                    if (d.length === 0)
                    {
                        handleReviewMissing();
                    }
                    else
                    {
                        setReviewId(reviewid);
                        setChildId(childid);
                        setIsLoading(false);
                    }
                }
                else
                {
                    location.assign(returnUrl);
                }
            },
            error: (jqXHR, textStatus, error) => {

                handleAjaxError(jqXHR, textStatus, error, returnUrl);
            }
        });
    }

    const closeWorkItem = (workitem) =>
    {
        const returnUrl = atob(return_url);

        $.ajax({
            type: 'DELETE',
            url: Globals.APIFolder + '/workitems/' + workitem,
            success: (data) => {

                if (checkError(data))
                {
                    location.assign(returnUrl);
                }
                else
                {
                    location.assign(returnUrl);
                }
            },
            error: (jqXHR, textStatus, error) => {

                handleAjaxError(jqXHR, textStatus, error, returnUrl);
            }
        });
    }

    const handleReviewMissing = () =>
    {
        const message = '<p>The progress review you are trying to view has been deleted.</p><p>Please click OK to remove this work item from your inbox.</p>'

        bootbox.alert({
            size: "large",
            title: "The operation failed",
            message: message,
            callback: function ()
            {
                closeWorkItem(workitem_id);
            }
        })
    }

    const renderedComponent = () =>
    {
        return (
            <div className="jumbotron">
                <p className="med">Update Progress Review</p>
                <div className='panel panel-default panel-base'>
                    <ChildProgressReviewHeaderForm key='HeaderFormDiv' child_id={childId} review_id={reviewId}/>
                    {childIsLoading === false &&
                        <ChildProgressReviewTabbedForm key='TabbeFormDiv' mode='edit' showSaveStatus={true} isPPPlus={isPPP} child_id={childId} user_type={user_type}
                                                       activePage='attendance' review_id={reviewId} workitem_id={workitem_id} return_url={return_url}/>}
                    { /* <TabProvider defaultKey={2}>
                        <ChildProgressReviewTabbedForm2 child_id={childId} academic_year={2025} school_term_id={9}/>
                    </TabProvider> */ }
                </div>
            </div>
        )
    }

    return isLoading === true ? <SpinnerDiv/> : renderedComponent();
};

export default UpdateProgressReviewPage;
